import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TokenIcon(props: IconProps) {
    return <Icon {...props} iconKey={"token"}/>
}
